export const autocomplete = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    placeholderColor: "{form.field.placeholder.color}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{form.field.focus.ring.width}",
      style: "{form.field.focus.ring.style}",
      color: "{form.field.focus.ring.color}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}",
    },
    transitionDuration: "{form.field.transition.duration}",
  },
  overlay: {
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}",
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}",
  },
  list: {
    padding: "{list.padding}",
    gap: "{list.gap}",
  },
  option: {
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusBackground: "{list.option.selected.focus.background}",
    color: "{list.option.color}",
    focusColor: "{list.option.focus.color}",
    selectedColor: "{list.option.selected.color}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    padding: "{list.option.padding}",
    borderRadius: "{list.option.border.radius}",
  },
  optionGroup: {
    background: "{list.option.group.background}",
    color: "{list.option.group.color}",
    fontWeight: "{list.option.group.font.weight}",
    padding: "{list.option.group.padding}",
  },
  dropdown: {
    width: "{form.field.icon.size}",
    // sm: {
    //   width: "2rem",
    // },
    // lg: {
    //   width: "3rem",
    // },
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.border.color}",
    activeBorderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
  },
  chip: {
    borderRadius: "{border.radius.4}",
  },
  emptyMessage: {
    padding: "{list.option.padding}",
  },
  colorScheme: {
    light: {
      chip: {
        //   focusBackground: "{surface.200}",
        //   focusColor: "{surface.800}",
      },
      dropdown: {
        background: "transparent",
        hoverBackground: "transparent",
        activeBackground: "transparent",
        color: "{form.field.icon.color}",
        hoverColor: "{form.field.icon.color}",
        activeColor: "{form.field.icon.color}",
      },
    },
    dark: {
      chip: {
        //   focusBackground: "{surface.200}",
        //   focusColor: "{surface.800}",
      },
      dropdown: {
        background: "transparent",
        hoverBackground: "transparent",
        activeBackground: "transparent",
        color: "{form.field.icon.color}",
        hoverColor: "{form.field.icon.color}",
        activeColor: "{form.field.icon.color}",
      },
    },
  },
  extend: {
    ui: {
      fontLeading: "{form.field.font.leading}",
      hoverColor: "{primary.support}",
    },
  },
  css: ({ dt }: any): string => `
    .p-autocomplete {
      line-height: ${dt("autocomplete.ui.font.leading")};
    }
    
    .p-autocomplete input:enabled:hover {
      border-color: ${dt("autocomplete.extend.ui.hover.color")};
    }
    .p-autocomplete input:focus {
      border-color: ${dt("autocomplete.extend.ui.hover.color")};
    }
  `,
};
